import { getCookie } from '@/utils/common'
import { getAppConfig } from '@/config/config'

export function isPurMode(): boolean {
  const config = getAppConfig()
  return getCookie(config.consent.pur.cookie) === 'true' || navigator.userAgent.search('ntvAdFree') > -1
}
